// When the feature is present, the user always gets the hybrid path.
export const useIsHybridSearch = () => {
  const userStore = useUserStore()
  return computed(() => userStore.hasHybridSearchFeature)
}
